// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"b905e631","1313":"b905e631","1874":"b905e631","3802":"3b0b5777"}[chunkId] + ".chunk.css";
};